module.exports = __webpack_public_path__ + "static/media/Logo_SLDL.53d5dd37.jpg";